const { isEmpty } = require('lodash');

const { prefectures, } = require('../config');

const { entries } = Object;

module.exports = {
  fields: () => {
    return {
      code: {
        label: '識別名',
        type: 'string',
        validations: {
          required: v => !isEmpty(v),
        },
      },
      postalCode: {
        type: 'string',
        label: '郵便番号',
        validations: {
          required: v => !isEmpty(v),
          format: v => (v || '').match(/^[0-9]{7}$/g),
        },
        inputProps: {
          type: 'tel',
        },
      },
      prefecture: {
        label: '都道府県',
        type: 'select',
        options: entries(prefectures).map(([k, v]) => ({ value: k, label: v })),
        validations: {
          required:  v => !isEmpty(v),
        },
      },
      city: {
        type: 'string',
        label: '市区郡町村',
        validations: {
          required: v => !isEmpty(v),
        },
      },
      address1: {
        type: 'string',
        label: '町・番地',
        validations: {
          required: v => !isEmpty(v),
        },
      },
      address2: {
        type: 'string',
        label: 'マンション・ビル名',
      },
      name: {
        label: 'ショップ名（事業者名）',
        type: 'string',
        validations: {
          required: v => !isEmpty(v),
        },
      },
      phone: {
        type: 'string',
        inputType: 'tel',
        label: '電話番号',
        validations: {
          required: v => !isEmpty(v),
        },
      },
    };
  },
};
